export const styles = {
  container: {
    my: '60px',
    display: 'flex',
    flexDirection: 'column',
    '& h2': {
      mx: 0,
      mb: [null, 11, null, 9],
    },
    transition: `all 250ms ease`,
  },
  reviewWrapper: {
    gap: 8,
    flexDirection: [null, 'column', null, null, 'row'],
    p: '1px',
    background: 'linear-gradient(180deg, #C6ECFD 0%, #0086C9 100%)',
    flexBasis: ['100%', '100%', '100%', '100%', '100%'],
    borderRadius: '24px',
    boxShadow: '0px 8px 20px 4px #41BEF60D, 0px 20px 24px -4px #004B8114',
  },
  reviewTextLeft: {
    position: 'relative',
    pt: [null, 6, null, 10],
    pb: 10,
    pr: [null, 4, 7, 8, 10],
    pl: [null, 4, 10],
    '& div:first-of-type': {
      fontWeight: 600,
    },
    gap: '8px',
    borderRight: 'none',
    background: 'white',
    maxWidth: ['100%', '100%', '100%', '100%', '42%'],
    alignContent: 'center',
    flexDirection: 'column',
    display: 'flex',
    textAlign: 'left',
    justifyContent: 'space-between', 
  },
  reviewTextLeftNoButton: {
    justifyContent: 'center', 
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
  },
  reviewTextRight: {
    flexDirection: 'column',
    position: 'relative',
    pt: [null, 6, null, 10],
    pb: 10,
    pr: [null, 4, 7, 8, 10],
    pl: [null, 4, 10],

    gap: '8px',
    borderLeft: 'none',
    background: 'white',
    maxWidth: ['100%', '100%', '100%', '100%', '58%'],
    alignContent: 'right',
  },
  review: {
    alignItems: 'center',
    borderRadius: '24px',
  },
  reviewLeft: {
    flexDirection: [null, 'column', null, null, 'row'],
    overflow: 'hidden',
    '& > div': {
      height: '100%',
      width: '100%'
    },
  },
};
